import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const MetadataSkeleton = () => {
    return (
        <div className="p-2">
            <div className="mb-6">
                {/* Metric Name */}
                <Skeleton height={14} width={150} className="mb-2" />

                {/* Definition */}
                <Skeleton count={2} height={10} width="100%" className="mb-4" />

                {/* Versions */}
                <div className="my-2">
                    {/* Why Include This Metric */}
                    <Skeleton height={12} width={160} className="mb-2" />
                    <Skeleton count={2} height={10} width="100%" className="mb-4" />

                    <Skeleton height={120} width="100%" className="mt-3"/>
                    
                    <div className="flex w-full mt-4 gap-6">
                        {/* Data Year */}
                        <div className="flex flex-col w-full">
                            <Skeleton height={10} width={80} className="mb-1" />
                            <Skeleton height={10} width={60} />
                        </div>

                        {/* Scope */}
                        <div className="flex flex-col w-full">
                            <Skeleton height={10} width={60} className="mb-1" />
                            <Skeleton height={10} width={80} />
                        </div>
                    </div>

                    <div className="flex flex-col w-full mt-4">
                        {/* Source */}
                        <div className="flex flex-col w-full">
                            <Skeleton height={10} width={60} className="mt-4 mb-1" />
                            <Skeleton height={10} width="100%" />
                        </div>

                        {/* Source URL */}
                        <div className="flex flex-col w-full mt-2">
                        <Skeleton height={10} width="100%" className="mt-2" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MetadataSkeleton;
